import React from 'react'
import { useEffect } from 'react';
import ReactLoading from "react-loading";

const CategoryButtons = ({submitInput,category , setCategory,loading,setIsDrawerVisible, isDrawerVisible}) => {


  return (
    <div className="cate sm:block hidden space-x-1 py-2 px-8 h-[3.5rem] bg-gradient-to-b from-[#150507] to-black overflow-hidden">





    <button onClick={()=>{setCategory("All");submitInput('All')}} type="button" className={`text-white ${category === "All" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>    All</button>


    <button onClick={()=>{setCategory("Entertainment");submitInput('Entertainment')}} type="button" className={`text-white ${category === "Entertainment" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> Entertainment</button>


    <button onClick={()=>{setCategory("Sports");submitInput('Sports')}} type="button" className={`text-white ${category === "Sports" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> Sports</button>


    <button onClick={()=>{setCategory("CodeWithHarry");submitInput('CodeWithHarry')}} type="button" className={`text-white ${category === "CodeWithHarry" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> CodeWithHarry</button>


    <button onClick={()=>{setCategory("chess");submitInput('chess')}} type="button" className={`text-white ${category === "chess" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>Chess</button>


    <button onClick={()=>{setCategory("News");submitInput('News')}} type="button" className={`text-white ${category === "News" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>News</button>


    <button onClick={()=>{setCategory("Food");submitInput('Food')}} type="button" className={`text-white ${category === "Food" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>   Food</button>


    <button onClick={()=>{setCategory("Politics");submitInput('Politics')}} type="button" className={`text-white ${category === "Politics" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>Politics</button>


    <button onClick={()=>{setCategory("Government");submitInput('Government')}} type="button" className={`text-white ${category === "Government" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>Government</button>


    <button onClick={()=>{setCategory("BCA");submitInput('BCA')}} type="button" className={`text-white ${category === "BCA" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>BCA</button>


    <button onClick={()=>{setCategory("AI");submitInput('AI')}} type="button" className={`text-white ${category === "AI" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> Ai</button>


    <button onClick={()=>{setCategory("Dance");submitInput('Dance')}} type="button" className={`text-white ${category === "Dance" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}>Dance</button>


    <button onClick={()=>{setCategory("Crafting");submitInput('Crafting')}} type="button" className={`text-white ${category === "Crafting" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> crafting</button>


    <button onClick={()=>{setCategory("Art");submitInput('Art')}} type="button" className={`text-white ${category === "Art" ? "bg-red-700" : "bg-black"} hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300  font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 `}> Art</button>





               </div>
  )
}

export default CategoryButtons
